/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import styles from './DayEntry.module.scss';
import {
  Container,
  Row,
  Col,
  Form,
  FormCheck,
  Button,
} from 'react-bootstrap';
import TextInput from '../TextInput/TextInput';
import DateInput from '../Datepicker/DateInput';
import Dropdown from '../Dropdown/Dropdown';
import MealEntry from '../MealEntry/MealEntry';
import { hourTypeOptions } from '../Dropdown/hourTypeOptions';

export type DayEntryProps = {
  dayEntry: any;
  setIsFormValid?: any;
  isSubmitting?: boolean;
  setShowEntryform?: any;
  setEntryIndex?: any;
  isEditEntry?: boolean;
  entryData?: any;
  setEditEntry?: any;
  tableEntryArray?: any;
  entryIndex?: number;
  weekDays?: any;
  setTableRowsCount?: any;
};

const DayEntry = ({
  dayEntry,
  setIsFormValid,
  isSubmitting,
  setShowEntryform,
  setEntryIndex,
  isEditEntry,
  entryData,
  setEditEntry,
  tableEntryArray,
  entryIndex,
  weekDays,
  setTableRowsCount,
}: DayEntryProps
) => {
  const startTimeInputFirst = document.getElementById('startTimeFirst');
  const endTimeInputFirst = document.getElementById('endTimeFirst');
  const startTimeInputSecond = document.getElementById('startTimeSecond');
  const endTimeInputSecond = document.getElementById('endTimeSecond');
  const dateWorkedInput = document.getElementById('dateWorked');
  const [date, setDate] = useState('');
  const [timeIn, setTimeIn] = useState('');
  const [timeOut, setTimeOut] = useState('');
  const [mealTime1, setMealTime1] = useState({});
  const [maxTableRowsCount, setMaxTableRowsCount] = useState('');
  const [mealTime2, setMealTime2] = useState({});
  const [isDateWorkedEmpty, setIsDateWorkedEmpty] = useState(false)
  const [selectedFieldName, setSelectedFieldName] = useState('')
  const [hourType1, setHourType1] = useState(undefined);
  const [type1Duration, setType1Duration] = useState('');
  const [type2Duration, setType2Duration] = useState('');
  const [hourType2, setHourType2] = useState(undefined);
  const [radioValue, setRadioValue] = useState<any>();
  const [submitEntry, setsubmitEntry] = useState(false)
  const [title, setTitle] = useState('')

  const lowerCaseTitle = title.toLowerCase();

  const radios = [
    { name: 'Yes', value: 'true' },
    { name: 'No', value: 'false' },
  ];

  const reset = () => {
    setShowEntryform(false)
    setEntryIndex(null)
    setEditEntry(false);
  }

  useEffect(() => {
    if (maxTableRowsCount) {
      setTableRowsCount(maxTableRowsCount)
    }
  }, [maxTableRowsCount])

  useEffect(() => {
    if (date) {
      setTitle(weekDays[new Date(date).getDay()]);
    }
  }, [date, isEditEntry])

  useEffect(() => {
    if (submitEntry) {
      const entry = {
        date: new Date(date),
        [`${lowerCaseTitle}TimeIn`]: timeIn,
        [`${lowerCaseTitle}TimeOut`]: timeOut,
        ...mealTime1,
        ...mealTime2,
        [`${lowerCaseTitle}BreakMissed`]: radioValue,
        [`${lowerCaseTitle}HoursType1`]: hourType1,
        [`${lowerCaseTitle}Hours1`]: type1Duration,
        [`${lowerCaseTitle}HoursType2`]: hourType2,
        [`${lowerCaseTitle}Hours2`]: type2Duration,
      };

      if (date) {
        const timeProps = ['TimeIn', 'TimeOut', 'FirstBreakStart', 'FirstBreakEnd', 'SecondBreakStart', 'SecondBreakEnd'];
        for (let i = 0; i < timeProps.length; i++) {
          try {
            const mDate = moment(date, 'MM-DD-YYYY');
            const timeProp = timeProps[i];
            const propName = `${title.toLocaleLowerCase()}${timeProp}`;
            const time = entry[propName];
            if (!time) break;
            const timeParts = time.split(':');
            const hour = parseInt(timeParts[0], 10);
            const minute = parseInt(timeParts[1] || 0, 10);
            const mTime = mDate.clone().set({ hour, minute });
            entry[`${propName}Orig`] = entry[propName];
            entry[propName] = new Date(mTime.format());
          } catch (error) { }
        }
      }

      if (!date && dateWorkedInput) {
        dateWorkedInput.style.borderColor = 'red'
      }

      const firstBreakStart = mealTime1[`${title.toLowerCase()}FirstBreakStart`];
      const firstBreakEnd = mealTime1[`${title.toLowerCase()}FirstBreakEnd`];
      const secondBreakStart = mealTime2[`${title.toLowerCase()}SecondBreakStart`];
      const secondBreakEnd = mealTime2[`${title.toLowerCase()}SecondBreakEnd`];

      if (firstBreakEnd && !firstBreakStart) {
        if (startTimeInputFirst) {
          startTimeInputFirst.style.borderColor = 'red';
        }
        return;
      } else if (secondBreakEnd && !secondBreakStart) {
        if (startTimeInputSecond) {
          startTimeInputSecond.style.borderColor = 'red';
        }
        return;
      } else if (firstBreakStart && !firstBreakEnd) {
        if (endTimeInputFirst) {
          endTimeInputFirst.style.borderColor = 'red';
        }
        return;
      } else if (secondBreakStart && !secondBreakEnd) {
        if (endTimeInputSecond) {
          endTimeInputSecond.style.borderColor = 'red';
        }
        return;
      } else if (date && timeIn && timeOut) {
        dayEntry(entry);
        reset();
      }
    }
    // eslint-disable-next-line
  }, [submitEntry]);

  useEffect(() => {
    if (isEditEntry) {
      setTimeIn(moment(entryData[lowerCaseTitle + 'TimeIn']).format('HH:mm'));
      setTimeOut(moment(entryData[lowerCaseTitle + 'TimeOut']).format('HH:mm'));
      setMealTime1({
        breakStart: entryData[`${lowerCaseTitle}FirstBreakStartOrig`],
        breakEnd: entryData[`${lowerCaseTitle}FirstBreakEndOrig`],
        breakDuration: entryData[`${lowerCaseTitle}FirstBreakDuration`],
      });
      setMealTime2({
        breakStart: entryData[`${lowerCaseTitle}SecondBreakStartOrig`],
        breakEnd: entryData[`${lowerCaseTitle}SecondBreakEndOrig`],
        breakDuration: entryData[`${lowerCaseTitle}SecondBreakDuration`],
      });
      setHourType1(entryData[`${lowerCaseTitle}HoursType1`]);
      setType1Duration(entryData[`${lowerCaseTitle}Hours1`]);
      setType2Duration(entryData[`${lowerCaseTitle}Hours2`]);
      setHourType2(entryData[`${lowerCaseTitle}HoursType2`]);
      setRadioValue(entryData[`${lowerCaseTitle}BreakMissed`]);
    }
  }, [entryIndex, title])

  useEffect(() => {
    if (isEditEntry) {
      setDate(entryData.date);
    }
  }, [entryIndex])

  useEffect(() => {
    if (date) {
      if (date && !timeIn && !timeOut) {
        setIsFormValid(false)
      } else if (date && timeIn && !timeOut) {
        setIsFormValid(false)
      } else {
        setIsFormValid(true)
      }
      setIsDateWorkedEmpty(false)
    }
  }, [date, timeIn, timeOut])

  useEffect(() => {
    setsubmitEntry(false);
    if (dateWorkedInput && startTimeInputFirst && startTimeInputSecond && endTimeInputFirst && endTimeInputSecond) {
      if (date) {
        dateWorkedInput.style.borderColor = ''
      }

      if (mealTime1[`${lowerCaseTitle}FirstBreakStart`]) {
        startTimeInputFirst.style.borderColor = ''
      }

      if (mealTime1[`${lowerCaseTitle}FirstBreakEnd`]) {
        endTimeInputFirst.style.borderColor = ''
      }

      if (mealTime2[`${lowerCaseTitle}SecondBreakStart`]) {
        startTimeInputSecond.style.borderColor = ''
      }

      if (mealTime2[`${lowerCaseTitle}SecondBreakEnd`]) {
        endTimeInputSecond.style.borderColor = ''
      }

    }
  }, [
    date,
    timeIn,
    timeOut,
    mealTime1[`${lowerCaseTitle}FirstBreakStart`],
    mealTime1[`${lowerCaseTitle}FirstBreakEnd`],
    mealTime2[`${lowerCaseTitle}SecondBreakStart`],
    mealTime2[`${lowerCaseTitle}SecondBreakEnd`]
  ])

  const checkWorkedDate = () => {
    if (date) {
      setIsDateWorkedEmpty(false);
    } else {
      setIsDateWorkedEmpty(true)
    }
  }


  return (
    <Container data-testid="DayEntry" className={styles.DayEntry}>
      <Row>
        <Col>
          <Row>
            <Col xs={12} md={6} lg={6}>
              <DateInput
                name='date'
                maxDate={new Date()}
                date={date}
                tableEntryArray={tableEntryArray}
                onValueChange={(val) => {
                  setDate(val)
                  setsubmitEntry(false)
                }}
                setMaxTableRowsCount={setMaxTableRowsCount}
              />
              {(!date && submitEntry) && <p style={{ color: 'red', fontSize: 12 }}>Please select a date</p>}
            </Col>
            <Col xs={12} md={3} lg={{ span: 3 }}>
              <TextInput
                title="Time In"
                onValueChange={(val) => {
                  setTimeIn(val)
                  setsubmitEntry(false)
                }}
                onClick={(name) => {
                  checkWorkedDate()
                  setSelectedFieldName(name)
                }}
                placeholder={'HH : MM'}
                type="time"
                isDisabled={!date}
                required={!!date}
                fieldValidation={!!date ? "required" : ''}
                name='timeIn'
                values={timeIn}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'timeIn'}
                isFieldInvalid={(submitEntry && date && !timeIn) ? true : false}
              />
              {isDateWorkedEmpty && selectedFieldName === 'timeIn' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
              {(date && !timeIn && submitEntry) && <p style={{ color: 'red', fontSize: 12 }}>Please select in time</p>}
            </Col>
            <Col xs={12} md={3} lg={{ span: 3 }}>
              <TextInput
                title="Time Out"
                onValueChange={(val) => {
                  setTimeOut(val)
                  setsubmitEntry(false)
                }}
                placeholder={'HH : MM'}
                type="time"
                isDisabled={!date}
                onClick={(name) => {
                  checkWorkedDate()
                  setSelectedFieldName(name)
                }}
                value={timeOut}
                required={!!date}
                fieldValidation={!!date ? "required" : ''}
                name='timeOut'
                values={timeOut}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'timeOut'}
                isFieldInvalid={(date && timeIn && !timeOut && submitEntry) ? true : false}
              />
              {isDateWorkedEmpty && selectedFieldName === 'timeOut' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
              {(date && timeIn && !timeOut && submitEntry) && <p style={{ color: 'red', fontSize: 12 }}>Please select out time</p>}
            </Col>
          </Row>
          <MealEntry
            entryNumber={'First'}
            mealData={setMealTime1}
            day={title}
            isDisabled={!date}
            setIsFormValid={setIsFormValid}
            isSubmitting={isSubmitting}
            mealEntryData={mealTime1}
            isEditEntry={isEditEntry}
            submitEntry={submitEntry}
            entryIndex={entryIndex}
            date={date}
            checkWorkedDate={checkWorkedDate}
            setSelectedFieldName={setSelectedFieldName}
            isDateWorkedEmpty={isDateWorkedEmpty}
            selectedFieldName={selectedFieldName}
          />
          <MealEntry
            entryNumber={'Second'}
            mealData={setMealTime2}
            day={title}
            date={date}
            isDisabled={!date}
            setIsFormValid={setIsFormValid}
            isSubmitting={isSubmitting}
            mealEntryData={mealTime2}
            isEditEntry={isEditEntry}
            submitEntry={submitEntry}
            entryIndex={entryIndex}
            checkWorkedDate={checkWorkedDate}
            setSelectedFieldName={setSelectedFieldName}
            isDateWorkedEmpty={isDateWorkedEmpty}
            selectedFieldName={selectedFieldName}
          />
          <Row>
            <Col>
              <div className={styles.Radios}>
                <FormCheck.Label className={styles.radioLabel}>
                  Missed or Untimely Meal/Breaks
                </FormCheck.Label>
                {radios.map((radio, index) => (
                  <div key={`default-${index}`} className="mb-2" onClick={() => {
                    checkWorkedDate()
                    setSelectedFieldName('checkBox')
                  }} >
                    <Form.Check
                      name='checkBox'
                      type={'radio'}
                      id={`radio${index}`}
                      label={radio.name}
                      checked={radioValue === radio.value}
                      value={radio.value}
                      onChange={(e) => setRadioValue(e.currentTarget.value)}
                      disabled={!date}

                    />
                  </div>
                ))}
              </div>
              {isDateWorkedEmpty && selectedFieldName === 'checkBox' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={6}>
              <Dropdown
                name='hourType1'
                title={'Hours Type'}
                onValueChange={setHourType1}
                options={hourTypeOptions}
                isDisabled={!date}
                values={hourType1}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'hourType1'}
                onClick={(name) => {
                  checkWorkedDate()
                  setSelectedFieldName('hourType1')
                }}
              />
              {isDateWorkedEmpty && selectedFieldName === 'hourType1' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
            </Col>
            <Col xs={12} md={6} lg={6}>
              <TextInput
                title={'Hours'}
                type="text"
                name='hour1'
                onValueChange={setType1Duration}
                placeholder={'ex: 23'}
                isDisabled={!date}
                pattern="\d*"
                inputMode={'decimal'}
                values={type1Duration}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'hour1'}
                onClick={(name) => {
                  checkWorkedDate()
                  setSelectedFieldName(name)
                }}
              />
              {isDateWorkedEmpty && selectedFieldName === 'hour1' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={6}>
              <Dropdown
                name='hourType2'
                title={'Hours Type'}
                onValueChange={setHourType2}
                options={hourTypeOptions}
                isDisabled={!date}
                values={hourType2}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'hourType2'}
                onClick={() => {
                  checkWorkedDate()
                  setSelectedFieldName('hourType2')
                }}
              />
              {isDateWorkedEmpty && selectedFieldName === 'hourType2' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
            </Col>
            <Col xs={12} md={6} lg={6}>
              <TextInput
                title={'Hours'}
                type="text"
                onValueChange={setType2Duration}
                placeholder={'ex: 23'}
                isDisabled={!date}
                name='hour2'
                pattern="\d*"
                inputMode={'decimal'}
                values={type2Duration}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'hour2'}
                onClick={(name) => {
                  checkWorkedDate()
                  setSelectedFieldName(name)
                }}
              />
              {isDateWorkedEmpty && selectedFieldName === 'hour2' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
            </Col>
          </Row>
          <div style={{ marginTop: 5 }}>
            {tableEntryArray.length > 0 &&
              < Button
                type='button'
                size='sm'
                variant="danger"
                onClick={(e) => reset()}
                style={{ float: 'right', marginLeft: 10 }}
              >
                Cancel
              </Button>}

            <Button
              type='button'
              size='sm'
              variant="success"
              onClick={(e) => setsubmitEntry(true)}
              style={{ float: 'right' }}
            >
              {isEditEntry ? 'Update' : 'Add'}
            </Button>
          </div>
        </Col>
      </Row>
    </Container >
  );
};

export default DayEntry;
